module.exports = {
    COMMUNICATION_FAILURE : {
        id : 100,
        reason : "Communication with server failed"
    },
    SESSION_CLOSED : {
        id : 101,
        reason : "Session is closed"
    },
    REQUEST_TIME_OUT : {
        id : 102,
        reason : "Request time out"
    },
    ACCESS_DENIED : {
        id : 103,
        reason : "Access denied"
    },
    TOPIC_TREE_REGISTRATION_CONFLICT : {
        id : 200,
        reason : "A conflicting, pre-existing registration exists on the same branch of the topic tree"
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/client/errors.js
// module id = 996
// module chunks = 0